
import { useState, useEffect } from 'react';

import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Card from 'react-bootstrap/Card';
import Modal from 'react-bootstrap/Modal';
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';
import CustomButton from '../../components/customButton';

import { FaPlus } from 'react-icons/fa';

import './finance.css';

export default function Finance() {
  const [loading, setLoading] = useState(true);
  const [payouts, setPayouts] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [accountHolderName, setAccountHolderName] = useState('');

  useEffect(() => {
    setPayouts([
      {
        'id': 1,
        'date': 'Thursday, January 5th 2023',
        'amount': '$17,625.00',
        'status': 'PAID',
      },
      { 
        'id': 2,
        'date': 'Thursday, January 4th 2023',
        'amount': '$4,000.00',
        'status': 'PAID',
      }
    ]);
    setLoading(false);
  }, []);


  const handleCloseModal = () => setShowModal(false);
  const handleShowModal = () => setShowModal(true);

  return (
    <>
      <section>
        <Container>
          <Row>
            <Col lg="4">
              <Card className="mb-3" style={{ width: '100%' }}>
                <Card.Body>
                  <Card.Title>Account Status</Card.Title>
                  <table className="table">
                    <tbody>
                      <tr>
                        <td>Sell Tickets</td>
                        <td>
                          <span className="badge">Enabled</span>
                        </td>
                      </tr>
                      <tr>
                        <td>Transfer Balance</td>
                        <td>
                          <span className="badge">Enabled</span>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </Card.Body>
              </Card>
              <Card className="mb-3" style={{ width: '100%' }}>
                <Card.Body>
                  <Card.Title>Balance</Card.Title>
                  <table className="table">
                    <tbody>
                      <tr>
                        <td>Available</td>
                        <td>$0.00</td>
                      </tr>
                      <tr>
                        <td>Pending</td>
                        <td>$0.00</td>
                      </tr>
                    </tbody>
                  </table>
                </Card.Body>
              </Card>
              <Card className="mb-3" style={{ width: '100%' }}>
                <Card.Body>
                  <Card.Title>Banks &amp; Debit Cards</Card.Title>
                  <Button variant="secondary" onClick={handleShowModal}>
                    Add <FaPlus />
                  </Button>
                </Card.Body>
              </Card>
            </Col>
            <Col lg="8">
              <Card className="mb-3" style={{ width: '100%' }}>
                <Card.Body>
                  <Card.Title>Payouts</Card.Title>
                  {loading && (
                    <p>Loading...</p>
                  )}
                  {(!loading && payouts.length == 0) && (
                    <p>You currently have no payment history.</p>
                  )}
                  {(!loading && payouts.length > 0) && (
                    <table className="table">
                      <thead>
                        <tr>
                          <th>Date</th>
                          <td>Amount</td>
                          <td>Status</td>
                        </tr>
                      </thead>
                      <tbody>
                        {payouts.map((payout, i) => {
                          return (
                            <tr key={payout.id}>
                              <td>{payout.date}</td>
                              <td>{payout.amount}</td>
                              <td>{payout.status}</td>
                            </tr>
                          );
                        })}
                      </tbody>
                    </table>
                  )}
                </Card.Body>
              </Card>
            </Col>
          </Row>
        </Container>
      </section>
      <Modal show={showModal} onHide={handleCloseModal}>
        <Modal.Header closeButton>
          <Modal.Title>Add Bank Account</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Form.Group className="mb-3" controlId="formBasicAccountHolderName">
              <Form.Label>Account Holder Name</Form.Label>
              <Form.Control type="text" placeholder="Account Holder Name" defaultValue={accountHolderName} onKeyUp={(event) => {
                setAccountHolderName(event.target.value)
              }}/>
              {/*<Form.Text className="text-gray">We'll never share your email with anyone else.</Form.Text>*/}
            </Form.Group>
            <CustomButton type="submit" color="green" text={!loading ? 'Add Bank Account' : 'Adding...'} className="add-bank-button"/>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleCloseModal}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}
